import React, { FC, useEffect, useState } from 'react';
import { Empty, Select, SelectProps, Spin } from 'antd';
import { debounce } from 'lodash';

import { Text } from '@/common/components';
import { useGetProductEntities } from '@/hooks';
import { ProductEntity } from '@/lib/PlannerDTOs';

interface IProductEntitySelect {
  productEntity?: string;
}

const NUM_OF_ITEMS = 15;

const ProductEntitySelect: FC<IProductEntitySelect & SelectProps> = ({
  productEntity = null,
  placeholder,
  onChange,
  ...others
}) => {
  const [searchTerm, setSearchTerm] = useState<string>(null);

  useEffect(() => {
    setSearchTerm(productEntity);
  }, [productEntity]);

  const { data, isLoading } = useGetProductEntities(
    searchTerm ?? '',
    '0',
    NUM_OF_ITEMS.toString(),
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return (
    <Select
      placeholder={placeholder || 'Select an option'}
      style={{
        width: 560,
      }}
      allowClear
      showSearch
      value={searchTerm}
      notFoundContent={
        isLoading ? (
          <div>
            <Spin size="small" style={{ margin: '0 8px' }} />
            <Text>Searching...</Text>
          </div>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      onSearch={debounce((e) => {
        setSearchTerm(e);
      }, 500)}
      onChange={onChange}
      {...others}
    >
      {data?.data?.items?.map((productEntity: ProductEntity) => (
        <Select.Option key={productEntity?.name} value={productEntity?.name}>
          {productEntity?.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ProductEntitySelect;
